// Global Instructions Rule Applied!
import React from 'react'
import { Select } from 'antd'
import { FundOption } from '../lib/useListFund.ts'

interface FundSelectProps {
  /** Funds that have prospects (from the prospects filter-options endpoint). */
  options: FundOption[]
  /** Currently selected fund id (null until resolved from options / the persisted pick). */
  value: string | null
  /** Commit a new fund selection. */
  onChange: (fundId: string) => void
}

/**
 * Fund switcher for the prospects list — the primary selector (replaces the pipeline
 * switcher). Lists the funds that have prospects; picking one scopes the list to that fund
 * and drives the Stage filter's pipeline. Renders nothing until options resolve.
 */
export function FundSelect({ options, value, onChange }: FundSelectProps): React.JSX.Element | null {
  if (!options || options.length === 0) return null

  return (
    <Select
      size="middle"
      style={{ minWidth: 180 }}
      value={value ?? undefined}
      onChange={onChange}
      options={options.map((f) => ({ value: f.id, label: f.name }))}
      aria-label="Fund"
    />
  )
}

export default FundSelect
